import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CameraService } from './services/camera.service';


@NgModule({
	imports: [
		CommonModule,
		IonicModule
	],
	providers: [
		CameraService
	]
})
export class CameraModule { }
